import React from "react";
import SeoHead from "../../../components/SeoHead";
import svg116 from "../../../assets/svg/svg116.svg";
import svg128 from "../../../assets/svg/svg128.svg";
import svg129 from "../../../assets/svg/svg129.svg";
import svg130 from "../../../assets/svg/svg130.svg";
import svg122 from "../../../assets/svg/svg122.svg";
import UtilityHero from "./UtilityHero";
import WorkSmarter from "../services/bulk-payment/WorkSmarter";
import JoinNetwork from "../services/bulk-payment/JoinNetwork";

const titleHero = "Pay All Your Bills Instantly and Securely";
const subtitleHero =
  "Water. Sanitation. Electricity. Airtime. SMS. Handle all your essential payments in one place";

const itemsSmarter = [
  {
    title: "All-in-One Platform",
    svg: svg128,
    desc: "Handle water, electricity, sanitation, airtime, and more from a single, unified dashboard.",
  },
  {
    title: "24/7 Availability",
    svg: svg129,
    desc: "Make payments anytime, anywhere. Impala Digital Payments is always on, just like your life.",
  },
  {
    title: "Instant Confirmation",
    svg: svg122,
    desc: "Every transaction is processed, verified, and receipted in seconds, no waiting, no uncertainty.",
  },
  {
    title: "Transparent & Secure",
    svg: svg116,
    desc: "Built with bank-grade encryption and compliance standards that keep your data and money safe.",
  },
  {
    title: "Automated Records",
    svg: svg130,
    desc: "Stay organized with real-time tracking, digital receipts, and auto-reconciliation for every payment.",
  },
];

const titleSmarter = "What Makes Impala Digital Payments Different";
const subtitleSmarter =
  "Every payment you make is seamless, secure, and instantly verified.";

const title = "Make Every Payment Effortless";
const subtitle =
  "Join thousands of Kenyan businesses and individuals who trust Impala Digital Payments for their daily payments.";
function Utility() {
  return (
    <div id="utility">
      <SeoHead title="Utility Bill Payments" description="Pay water, electricity, airtime and sanitation bills instantly. Handle all essential utility payments in one place with Impala Digital Payments." path="/utility" />
      <UtilityHero title={titleHero} subtitle={subtitleHero} />
      <WorkSmarter
        items={itemsSmarter}
        title={titleSmarter}
        subtitle={subtitleSmarter}
      />
      <JoinNetwork title={title} subtitle={subtitle} />
    </div>
  );
}

export default Utility;
